// Welke brief staat standaard klaar op de printpagina (Letter.jsx)?
//
// Bij het eerste meetmoment van een onderzoek de voormeting-brief, bij een
// later meetmoment de nameting-brief. 'Eerste' = laagste Position, gelijkspel
// op ID — dezelfde regel als de server gebruikt om een voormeting te herkennen
// (functions/addressMatching/matchQuestionnaireAddress.js, kindOfMoment).
// Hier alleen een voorkeur: de gebruiker kan altijd een ander sjabloon kiezen.
// AI-CONTEXT: See docs/pitfalls.md#database-coarse-sort-key-ties-break-arbitrarily

/**
 * @param {Array<{ID: string, Position?: number}>|string} moments - '' zolang ze laden
 * @param {string} momentId
 * @returns {'voor'|'na'|''}
 */
const momentKindOf = (moments, momentId) => {
    if (!Array.isArray(moments) || moments.length === 0) return ''
    const sorted = [...moments].sort((a, b) =>
        (Number(a.Position) || 0) - (Number(b.Position) || 0) || String(a.ID).localeCompare(String(b.ID)))
    if (!sorted.some((m) => m.ID === momentId)) return ''
    return sorted[0].ID === momentId ? 'voor' : 'na'
}

/**
 * @param {Array<{ID: string, MomentKind: string}>} templates
 * @param {'voor'|'na'|''} kind
 * @returns {object|null}
 */
const chooseLetterTemplate = (templates, kind) => {
    if (!Array.isArray(templates) || templates.length === 0) return null
    return templates.find((t) => kind && t.MomentKind === kind) || templates[0]
}

/**
 * De brieven die bij de soort QR-pagina horen: bij een onderzoek de voor- en
 * nameting, bij een registratieformulier (output) de outputbrieven, bij een
 * storytelling-deellink de storytellingbrieven.
 *
 * @param {Array<{MomentKind: string}>} templates
 * @param {string} route - 'research' | 'event' | 'storytelling' (zoals op de QR-pagina)
 * @returns {Array<object>}
 */
const lettersFor = (templates, route) => {
    if (route === 'event') return templates.filter((t) => t.MomentKind === 'output')
    if (route === 'storytelling') return templates.filter((t) => t.MomentKind === 'storytelling')
    if (route === 'research') return templates.filter((t) => t.MomentKind === 'voor' || t.MomentKind === 'na')
    return []
}

export { lettersFor, momentKindOf }
export default chooseLetterTemplate
